import React, {useRef} from 'react';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import validate from './validateInfo';
import useForm from './useForm';


const FormStyle = styled.form`
  width: 100%;
  .form-group {
    width: 100%;
    margin-bottom: 2rem;
  }
  label {
    font-size: var(--fs-md);
    font-weight: bold;
  }
  input,
  textarea {
    width: 100%;
    font-size: var(--fs-md);
    padding: 10px;
    color: var(--dark-text);
    background-color: var(--dark-footer);
    outline: none;
    border: none;
    border-radius: var(--radius-sm);
    margin-top: 1rem;
  }
  textarea {
    min-height: 250px;
    resize: vertical;
  }
  .sendError {
    color: #bd2e2e;
    font-size: var(--fs-sm);
    margin-top: 1rem;
  }
  .contactreqs{
    color: #bd2e2e;
    font-size: var(--fs-sm);
    font-weight: normal;
  }
  .btn {
    margin-top: 0.5rem;
  }
  .btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ContactForm = ({submitForm}) => {
  const form = useRef();
  const {t} = useTranslation(['contact']);
  const { handleChange, handleSubmit, values, errors, isSubmitting, sendError } = useForm(
    submitForm,
    validate
  );
  
  

  return (
    <>
      <FormStyle ref={form} onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">
          {t("yourname")}
            <input
              type="text"
              id="name"
              name="name"
              value={values.name}
              onChange={handleChange}
            />
             {errors.name && <p className="contactreqs">{t(errors.name)}</p>}
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="email">
          {t("youremail")}
            <input
              type="email"
              id="email"
              name="email"
              value={values.email}
              onChange={handleChange}
            />
           {errors.email && <p className="contactreqs">{t(errors.email)}</p>}

          </label>
        </div>
        <div className="form-group">
          <label htmlFor="message">
          {t("yourmessage")}
            <textarea
              type="text"
              id="message"
              name="message"
              value={values.message}
              onChange={handleChange}
            />
             {errors.message && <p className="contactreqs">{t(errors.message)}</p>}

          </label>
        </div>
        <button type="submit" className="btn btn--primary btn--large" disabled={isSubmitting}>
          {isSubmitting ? 'Sending…' : t("send")}
        </button>
        {sendError && (
          <p className="sendError">Something went wrong sending your message — please try again, or email me directly.</p>
        )}
      </FormStyle>
    </>
  );
};

export default ContactForm;
